/* eslint-disable no-shadow */

export enum ChangeMainDomainProcessStatus {
  None = 'none',
  InProgress = 'inProgress',
  Failed = 'failed',
}

export enum SiteDomainsGatewayKeys {
  UpdateMainChangingProcessStatus = 'updateMainChangingProcessStatus',
}
